import React, {PureComponent} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import renderSubdomainInput from '../../../shared/components/form/SubdomainInput';
import config from '../../../config';
import renderInputField from '../../../shared/components/form/renderInput';
import LockOpenIcon from 'mdi-react/LockOpenIcon';
import LockIcon from 'mdi-react/LockIcon'
import Collapse from '../../../shared/components/Collapse';
import renderCheckBoxField from "../../../shared/components/form/CheckBox";
import {withTranslation} from "react-i18next";

class BasicSettings extends PureComponent {

    constructor() {
        super();
        this.state = {
            domainEditable: false,
            customDomainVisible: false
        }
    }

    render() {
        const {handleSubmit, blog, t} = this.props;

        return (
            <Col xs={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{blog.title}</h5>
                            <h5 className="subhead">{blog.slogan}</h5>
                        </div>
                        <form className="form form--horizontal" onSubmit={handleSubmit}>
                            <div className="form__form-group">
                                <span className="form__form-group-label">{t('settings.form_title.label')}:</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="title"
                                        component={renderInputField}
                                        type="text"
                                        placeholder={t('settings.form_title.placeholder')}
                                        value={blog.title}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">{t('settings.form_slogan.label')}:</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="slogan"
                                        component="input"
                                        type="text"
                                        placeholder={t('settings.form_slogan.placeholder')}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">

                                <div className="form__form-group">
                                    <span className="form__form-group-label">{t('settings.form_address.label')}:</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name='domain'
                                            defaultValue={blog.domain}
                                            component={renderSubdomainInput}
                                            disabled={!this.state.domainEditable}
                                            domains={config.DOMAINS}
                                        />
                                        <button
                                            type="button"
                                            className={`form__form-group-button${this.state.domainEditable ? ' active' : ''}`}
                                            onClick={() => this.setState({domainEditable: !this.state.domainEditable})}>
                                            {this.state.domainEditable ? <LockOpenIcon/> : <LockIcon/>}
                                        </button>
                                    </div>
                                </div>
                                <h5 className="subhead">{t('settings.form_address.description')}</h5>
                            </div>
                            {/*<h5><a href={'#'} >I wan't to config my own domain</a></h5>*/}
                            {(!this.props.blog.custom_domain && !this.state.customDomainVisible) &&
                            <button type="button" className={"btn btn-outline-primary btn-sm"} onClick={() => {
                                this.setState({customDomainVisible: true})
                            }}>
                                {t('settings.form_custom_domain.i_want_to_setup_custom_domain')}
                            </button>}
                            {(this.state.customDomainVisible || this.props.blog.custom_domain) &&
                            <div className="form__form-group">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">{t('settings.form_custom_domain.label')}:</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="custom_domain"
                                            normalize={(value) => value === '' ? null : value}
                                            component={renderInputField}
                                            type="text"
                                            placeholder="example.com"
                                        />
                                    </div>
                                </div>
                                <div className="form__form-group">
                                    <div className="form__form-group-field">
                                        <Field
                                            name="domain_redirect"
                                            component={renderCheckBoxField}
                                            label={t('settings.form_custom_domain.redirect')}
                                            className="colored-click"
                                        />
                                    </div>
                                </div>
                                <Collapse title={t('settings.form_custom_domain.how_to_configure_custom_domain')}>
                                    <span><p>We do not store any DNS settings for your domain so you need to use your
                                        registrar's default Name Servers.</p>
                                        <span>
                                        <ol>
                                            <li>Visit your domain registrar website</li>
                                            <li>Open the DNS settings.</li>
                                            <li>Add following records:
                                                <ul className="icons-list icons-list--green">
                                                    <li><strong>A</strong> with your domain as a host
                                                        and {config.SERVER_IP} as a target
                                                    </li>
                                                    <li><strong>CNAME</strong> with <em>www</em> as a host and your
                                                        domain as a target
                                                    </li>
                                                </ul>
                                            </li>
                                        </ol>
                                    </span>
                                        <p>In case of any problems, just visit <strong>#helpdesk</strong> channel on
                                            our <a
                                                target="_blank noreferrer"
                                                href="https://discordapp.com/invite/8NktdFh">Discord</a> server.</p></span>
                                </Collapse>
                            </div>}
                        </form>

                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default reduxForm({
    form: 'blog_settings'
})(withTranslation('dashboard')(BasicSettings));


